<template>
    <div id="workShopEquipDetail">
    	<!-- table -->
    	<el-scrollbar 
    		style="width: 100%;height: 100%;display: inline-block;" 
    		wrap-style="overflow-x: hidden;"
    		view-style="width: 1617px;">
    		<el-collapse v-model="activeNames" @change="handleChange" style="width: 99.4%">
    			<el-collapse-item title="备件状态" name="1">
				    <el-table :data="replacement">
	                    <el-table-column prop="location" label="位置"></el-table-column>
	                    <el-table-column prop="modelType" label="型号"></el-table-column>
	                    <el-table-column prop="quantity" label="数量" width="120"></el-table-column>
	                </el-table>
				</el-collapse-item>
				<el-collapse-item title="专家库" name="2">
					<el-table :data="warnReport">
	                    <el-table-column prop="warnId" label="报警号"></el-table-column>
	                    <el-table-column prop="warnContent" label="报警内容"></el-table-column>
	                    <el-table-column prop="warnProcess" label="处理过程"></el-table-column>
	                    <el-table-column prop="photo" label="上传照片"></el-table-column>
	                </el-table>
				</el-collapse-item>
				<el-collapse-item title="维保信息" name="3">
					<el-table :data="maintenance" style="width: 100%">
	                    <el-table-column prop="deviceName" label="设备名称"></el-table-column>
	                    <el-table-column prop="deviceCode" label="设备编码"></el-table-column>
	                    <el-table-column prop="deviceType" label="设备类型"></el-table-column>
	                    <el-table-column prop="manufacturer" label="制造商"></el-table-column>
	                    <el-table-column prop="startDate" label="启动日期"></el-table-column>
	                    <el-table-column prop="maintainDate" label="保养日期设定"></el-table-column>
	                    <el-table-column prop="maintainConfirm" label="保养情况确认"></el-table-column>
	                </el-table>
				</el-collapse-item>
    		</el-collapse>
    	</el-scrollbar>
	</div>
</template>

<script>

export default {
	name: 'workShopEquipDetail',
	data () {
		return {
			deviceId: 0,
			activeNames: [],
			replacement: [],//备用件
			warnReport: [],//专家库
			maintenance: [],//维保信息
		}
	},
	beforeMount(){
		this.deviceId = this.$route.query.deviceId;

		this.replacement = [
			{location: '钻头', modelType: 'M4', quantity: 3},
			{location: '钻头', modelType: 'M6', quantity: 2},
			{location: '钻头', modelType: 'M8', quantity: 1},
		];
		this.warnReport = [
			{warnId: 111, warnContent: '钻头损坏', warnProcess: '更换钻头', photo: 'http://xxx.xx.xx'},
			{warnId: 115, warnContent: '主轴过热', warnProcess: '添加润滑剂', photo: 'http://xxx.xx.xx'},
		];
		this.maintenance = [
			{deviceName: 'C6132车床', deviceCode: 'C6132-5865', deviceType: '车床', manufacturer: '沈阳某某工', startDate: '2018-01-01', maintainDate: '2018-12-22', maintainConfirm: '已确认'}
		];
	},
	mounted() {
		
	},
    computed: {
    	
    },
	methods:{
		handleChange(val) {
		},
	},
	components: {
		
	}
}
</script>

<style>
#workShopEquipDetail {
	height: 100%;
}

#workShopEquipDetail .el-collapse {
	border-top: none;
}

#workShopEquipDetail .el-collapse-item__wrap {
	border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/views/workshop/WorkShopEquipDetail.vue